"use strict";

import {isset} from '../js-utilities';
import ManagerHelper from './helpers/manager-helper';
import {generateValueOutput} from "./helpers/calculator-helpers";

// Fmd
export default class FmdManager {
    constructor(controller, language) {
        this.controller = controller;
        this.language = language;

        this.$fmdSummary = $('#fmd_summary');
        this.$fmdSummaryValue = $('#fmd_summary_value');

        this.$fmdOutputCellLabel = $('#fmd_output_cell_label');
        this.$fmdOutputCellValue = $('#fmd_output_cell_value');
        // Icon is not being used but since the functionality works I don't want to remove it, in case we use it again
        this.$fmdOutputCellIcon = $('#fmd_output_cell_icon');

        this.fmdHelper = new ManagerHelper('fmd', this.controller, this.updateFmdAgeInfluence.bind(this));
    }

    reconfigureFmdInput() {
        if (this.fmdHelper) {
            this.fmdHelper.configureInput();
        }
    }

    callGenerateSliderGradients() {
        if (this.fmdHelper) {
            this.fmdHelper.callGenerateSliderGradient();
        }
    }

    // Would like to make this a generic method in the manager helper, but there's still enough deviation that this is simpler
    updateFmdAgeInfluence(fmd = this.controller.current_values.fmd) {
        if (isset(fmd) && isset(this.controller.current_values.gender)) {
            const response = this.controller.calculator_4.ageChangeForValue('fmd', fmd, this.controller.current_values.fractional_age, this.controller.current_values.gender);
            this.populateFmdOutput(response);
        } else {
            this.populateFmdOutput();
        }
    }

    // Would like to make this a generic method in the manager helper, but there's still enough deviation that this is simpler
    populateFmdOutput(response) {
        const fmdOutput = generateValueOutput('fmd', response, this.controller);

        this.controller.current_age_changes.fmd = fmdOutput.ageChange;
        this.controller.current_values.fmd_change = fmdOutput.ageChangeText

        this.$fmdSummary.html(fmdOutput.summary);
        this.$fmdSummaryValue.html(fmdOutput.summaryValue);

        this.$fmdOutputCellLabel.html(fmdOutput.outputCellLabel);
        this.$fmdOutputCellValue.html(fmdOutput.outputCellValue).css('color', fmdOutput.outputCellColor);
        // Icon is not being used but since the functionality works I don't want to remove it, in case we use it again
        this.$fmdOutputCellIcon.prop('src', fmdOutput.outputCellIcon);

        this.controller.calculate_vascular_age();
    }

    // public method for controller to enable and disable UI controls
    enableControls(enable) {
        this.fmdHelper.enableControls(enable);
    }

}
